import {
  ListShortDataT,
  ListResponseDataT,
} from "@interfaces/internal-study/list";
import {
  InternalListTraineesMember,
  InternalTrainingSteps,
  DownloadProtocolFileParams,
} from "@interfaces/store/internal-list-store-types";

import Fetcher from "@http/fetcher";
import { ResCallback } from "@interfaces/common";

class InternalStudyListService {
  static async getAll(companyId: number, cb: ResCallback<ListShortDataT[]>) {
    try {
      const res = await Fetcher.get<ListShortDataT[]>(
        "/educational-center/internal-training/list",
        {
          params: {
            companyId,
          },
        }
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async getById(
    id: string,
    companyId: number | null,
    cb: ResCallback<ListShortDataT>
  ) {
    try {
      const res = await Fetcher.get<ListShortDataT>(
        `/educational-center/internal-training/list/${id}?companyId=${companyId}`
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      return cb(err);
    }
  }

  static async create(
    companyId: number,
    title: string,
    comission: number,
    trainees_members: InternalListTraineesMember[],
    cb: ResCallback<ListResponseDataT>
  ) {
    try {
      const res = await Fetcher.post<ListResponseDataT>(
        "/educational-center/internal-training/list",
        {
          title,
          companyId,
          comission,
          trainees_members,
        }
      );

      if (res.status === 201) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async process(data: {
    id: string;
    from: InternalListTraineesMember[];
    to: InternalTrainingSteps.Process | InternalTrainingSteps.Finish;
  }) {
    const resp = await Fetcher.patch<ListShortDataT>(
      `/educational-center/internal-training/list/${data.id}/process`,
      data
    );
    return resp.data;
  }

  static async finish(data: { id: string; file: File }) {
    const formData = new FormData();
    formData.append("file", data.file, data.file.name);

    const res = await Fetcher.post<ListShortDataT>(
      `/educational-center/internal-training/list/${data.id}/finish`,
      formData
    );

    return res.data;
  }

  static async update(
    id: number,
    title: string,
    comission: number,
    cb: ResCallback<string>
  ) {
    try {
      const res = await Fetcher.patch<string>(
        `/educational-center/internal-training/list/${id}`,
        {
          title,
          comission,
        }
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async removeTrainess(data: { id: number; members: number[] }) {
    const resp = await Fetcher.patch<ListShortDataT>(
      `/educational-center/internal-training/list/${data.id}/trainess-remove`,
      data
    );
    return resp.data;
  }

  static async removeTrainessProcess(data: { id: number; memberId: number }) {
    const resp = await Fetcher.patch<ListShortDataT>(
      `/educational-center/internal-training/list/${data.id}/process-remove`,
      data
    );
    return resp.data;
  }

  static async addTrainessToGroup(data: {
    id: number;
    index: number;
    members: InternalListTraineesMember[];
  }) {
    const resp = await Fetcher.patch<ListShortDataT>(
      `/educational-center/internal-training/list/${data.id}/trainess-add-group`,
      data
    );
    return resp.data;
  }

  static async delete(id: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.delete<string>(
        `/educational-center/internal-training/list/${id}`
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async downloadXml({ id, filename }: DownloadProtocolFileParams) {
    const resp = await Fetcher.get<Blob>(
      `/educational-center/internal-training/list/${id}/download/xml/${filename}`,
      {
        responseType: "blob",
      }
    );

    return resp.data;
  }

  static async downloadProtocol({ id, filename }: DownloadProtocolFileParams) {
    const resp = await Fetcher.get<Blob>(
      `/educational-center/internal-training/list/${id}/download/protocol/${filename}`,
      {
        responseType: "blob",
      }
    );

    return resp.data;
  }
}

export default InternalStudyListService;
